import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    console.log("params", params);
    return axios.get('stadium-special-operation/list', { params });
  },
  async open(params: any) {
    return axios.post('stadium-special-operation/open', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('stadium-special-operation/update', qs.stringify(params));
  },
};
